<template>
  <div>
    <h2>Saved Plans</h2>
    <a :href="`${base}/api/logs/export.php`" class="submit-button" >Export to Spreadsheet</a>
    <table>
      <thead>
      <tr>
        <th>Name</th>
        <th>Plan Chosen</th>
        <th>Discount code used</th>
        <th>Monthly Amount paid</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="log in logs">
        <td>{{ log['first-name'] }} {{ log['last-name'] }}</td>
        <td>{{ log['plan'] }}</td>
        <td>{{ log['discount-code'] ? log['discount-code'] : 'None' }}</td>
        <td>£{{ parseFloat(log['monthly-amount']).toFixed(2) }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "OrderLog",
  props: {
    base: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      logs: [],
    }
  },
  mounted() {
    this.getLogs();
  },
  methods: {
    getLogs() {
      this.$axios.get(`${this.base}/api/logs/get.php`)
          .then(response => {
            this.logs = response.data;
          });
    },
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 50%;
  border-collapse: collapse;
  border: {
    left: 1px solid #CCD0D4;
    right: 1px solid #CCD0D4;
    bottom: 1px solid #CCD0D4;
  }

  thead {
    th {
      border: {
        top: 1px solid #CCD0D4;
        bottom: 1px solid #CCD0D4;
      }
      font-weight: normal;
      color: #32373C;
      background-color: #FFF;
      padding: 0.5rem;
      text-align: left;
    }
  }

  td {
    padding: 0.5rem;
  }

  tr:nth-child(odd) {
    background-color: #F9F9F9;
  }

  tr:nth-child(even) {
    background-color: #FFF;
  }

}

.submit-button {
  display: inline-block;
  text-decoration: none;
  margin: 1rem 0;
  background-color: #005EAE;
  color: #FFF;
  border-radius: 5px;
  padding: 0.5rem;
  border: none;
  outline: none;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background-color: #004885;
    transition: 0.2s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/OrderLog.vue